import React from "react";
import { useNavigate } from "react-router-dom";
import { Modal, Button } from "./ui";
import Icon from "./Icon";
import Mascot from "./Mascot";
import { useAuth } from "../context/AuthContext";

// Shown when someone tries to save while exploring the read-only demo.
export default function TrialNudge() {
  const { nudgeOpen, closeNudge, family, isNativeBilling } = useAuth();
  const navigate = useNavigate();
  const p = family?.pricing || { founder_monthly: 4.99, annual_total: 34.99, trial_days: 7 };

  return (
    <Modal open={nudgeOpen} onClose={closeNudge} testid="trial-nudge">
      <div className="text-center">
        <Mascot size={120} className="mx-auto mb-1" />
        <div className="inline-flex items-center gap-1.5 rounded-full bg-sunny/20 text-sunny-fg px-3 py-1 text-xs font-black uppercase tracking-wider mb-3">
          <Icon name="lock" width={13} height={13} /> Demo is read-only
        </div>
        <h2 className="font-heading font-black text-2xl text-ink leading-tight">Loving it? Make it yours!</h2>
        <p className="text-ink-soft font-semibold mt-2 mb-5 px-2">
          The demo lets you play with everything, but changes aren't saved. Start your free {p.trial_days}-day trial to
          build your own family — <span className="text-primary-dark">no card needed</span>. {isNativeBilling ? "Choose a plan in your store when you're ready to continue." : `Then choose $${p.founder_monthly}/mo or $${p.annual_total}/yr.`}
        </p>
        <Button size="lg" className="w-full" data-testid="nudge-start-trial"
          onClick={() => { closeNudge(); navigate("/register"); }}>
          <Icon name="rocket" width={18} height={18} /> Start my free {p.trial_days}-day trial
        </Button>
        <button onClick={closeNudge} data-testid="nudge-keep-exploring"
          className="mt-3 text-sm font-bold text-ink-muted hover:text-ink-soft">
          Keep exploring the demo
        </button>
      </div>
    </Modal>
  );
}
